import React from "react";
import { motion } from "framer-motion";

const MILESTONES = [
  { year: "1955", title: "Foundation", desc: "Conceived through the vision of Late Shri K. Muthiah — R K STEEL is founded on principled procurement and industrial trust." },
  { year: "1972", title: "National Reach", desc: "Expanded operations across India — supplying steel to critical infrastructure projects." },
  { year: "1988", title: "Diversification", desc: "Entered non-ferrous procurement and rubber recycling — copper, aluminium, brass and industrial rubber materials." },
  { year: "2003", title: "Global Trade", desc: "First international shipment. Established trade corridors to the Middle East & Western Markets." },
  { year: "2015", title: "Digital Trade", desc: "Modernized logistics and traceability systems for global clientele." },
  { year: "2025", title: "70 Years", desc: "A seven-decade legacy — trusted by 100+ clients across 30+ countries." },
];

export const Timeline = () => (
  <div data-testid="timeline" className="relative">
    <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-[#12355B]/10 via-[#12355B] to-[#12355B]/10" />
    <ol className="space-y-16">
      {MILESTONES.map((m, i) => {
        const isRight = i % 2 === 0;
        return (
          <motion.li
            key={m.year}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className={`relative pl-14 md:pl-0 md:grid md:grid-cols-2 md:gap-16 items-center`}
          >
            <div className="absolute left-4 md:left-1/2 top-3 -translate-x-1/2 w-4 h-4 rounded-full bg-[#2F9E44] ring-4 ring-white shadow-lg" />
            <div className={`${isRight ? "md:col-start-1 md:text-right md:pr-16" : "md:col-start-2 md:pl-16"}`}>
              <div className="font-display text-5xl md:text-6xl font-light text-[#12355B] tracking-tighter">{m.year}</div>
              <h3 className="font-heading font-medium text-xl mt-2 text-[#222629]">{m.title}</h3>
              <p className="mt-3 text-neutral-600 leading-relaxed max-w-md md:inline-block">{m.desc}</p>
            </div>
          </motion.li>
        );
      })}
    </ol>
  </div>
);

export default Timeline;
